import PickerInput from "../PickerInput/PickerInput";

export const LocationPickerInput = PickerInput;
